'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var MapContext = require('./MapContext.js');

/* global google */
var Map = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, id = _a.id, onClick = _a.onClick, props = tslib.__rest(_a, ["children", "className", "id", "onClick"]);
    var _c = react.useState(), map = _c[0], setMap = _c[1];
    var _d = react.useState([]), markers = _d[0], setMarkers = _d[1];
    var isReady = !!map;
    var propsRef = react.useRef(props);
    react.useEffect(function () {
        var additionalProps = propsRef.current || {};
        var m = new google.maps.Map(document.getElementById(id), tslib.__assign({}, additionalProps));
        setMap(m);
    }, [id]);
    react.useEffect(function () {
        var listeners = [];
        if (map && onClick) {
            var clickListener = map.addListener('click', function () { return onClick(map); });
            listeners.push(clickListener);
        }
        return function () {
            if (listeners.length > 0) {
                listeners.map(function (listener) {
                    return window.google.maps.event.removeListener(listener);
                });
            }
        };
    }, [map, onClick]);
    var addMarker = react.useCallback(function (marker) { return setMarkers(function (prev) { return tslib.__spreadArray(tslib.__spreadArray([], prev, true), [marker], false); }); }, []);
    var context = {
        addMarker: addMarker,
        isReady: isReady,
        map: map,
        markers: markers
    };
    return (jsxRuntime.jsx(MapContext.default.Provider, tslib.__assign({ value: context }, { children: jsxRuntime.jsx("div", tslib.__assign({ className: className, id: id }, { children: children })) })));
};
var Map$1 = Map;

exports.default = Map$1;
//# sourceMappingURL=Map.js.map
